import * as React from 'react';
import { FormSelect } from 'source/app/presentation/Shared/Form/Select/FormSelect';
import { GetEnumValues } from 'motw_core/Utils/EnumUtils';
import { ETexture } from 'source/app/services/UI/Background/Texture/ETexture';

export const PatternSelector = ({
	patternName,
	setPatternName
}: {
	patternName: string;
	setPatternName: React.Dispatch<React.SetStateAction<string>>;
}) => {
	const allPatternNames = GetEnumValues(ETexture).map(
		(enumValue) => ETexture[enumValue]
	);

	return (
		<FormSelect
			id="patternSelector"
			width="auto"
			maxWidth="80%"
			suggestions={allPatternNames}
			onChange={(event) => setPatternName(event.target.value)}
			value={patternName}
		/>
	);
};
